import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { PILLAR_ENVIRONMENTAL } from "utils/constants/pillars"

// Renders a single RGAA/RGESN dashboard for one assessed page. The tab bar
// lives in the page template, so this organism only owns the chart widget.
const WebsiteExploreChartOrganism = ({ alias, websiteId }) => (
  <div className="Verdikt-Score">
    <div className={classNames(PILLAR_ENVIRONMENTAL, "page-frame")}>
      <div className={classNames("page")}>
        <div
          className={classNames(
            PILLAR_ENVIRONMENTAL,
            "widget",
            "chart",
            "transparent-widget"
          )}
        >
          <MetabaseChartMolecule
            key={`${alias}-${websiteId}`}
            verdikt_alias={alias}
            website_id={websiteId}
          />
        </div>
      </div>
    </div>
  </div>
)

WebsiteExploreChartOrganism.propTypes = {
  alias: PropTypes.string.isRequired,
  websiteId: PropTypes.number.isRequired,
}

export default WebsiteExploreChartOrganism
